import { getCoordinatorApi } from "@/lib/api";

export async function deleteProject(
  projectId: string,
  organizationId: string,
  activeProjectId: string
): Promise<
  | {
      error?: string;
    }
  | undefined
> {
  const api = getCoordinatorApi({ organizationId });
  // If the project is active, you can't delete it
  if (projectId === activeProjectId) {
    return {
      error: "You cannot delete the active project",
    };
  }

  await api.delete(`/projects/${projectId}`);
}
